<div class="card d-none d-lg-block">
  <div routerLink="/events/{{event.id}}" class="card-top">
    <img [src]="event.image" alt="Blog Name">
  </div>
  <div class="card-info" style="  padding: 0px 20px;">
    <h2 class="text-truncate text-center">{{event.name}}</h2>
    <span class="date text-center">{{event.dateStart | date : 'dd/MM/yyyy, h:mm a' : 'GMT'}}</span>
    <!-- <p class="excerpt">{{event.desc}}</p> -->
  </div>
  <div class="mb-2 flex-row  d-flex justify-content-center" style="  padding: 0px 20px;">
    <div class="col-12  d-flex justify-content-center  align-items-center row ">

      <button class="col-12 " routerLink="/events/{{event.id}}" mat-raised-button color="primary">
        <mat-icon>confirmation_number</mat-icon> COMPRAR AHORA
      </button>


    </div>
  </div>

  <div class="card-footer text-muted text-center">
    <div class="d-flex justify-content-center  align-items-center">
      <mat-icon>location_on</mat-icon>
      <a style="text-decoration: none;color:unset" href="https://www.google.cl/maps/search/{{event.address}}"
        target="_blank">
        <h5 style="margin-bottom: 0px;" class="text-truncate-2-line">{{event.address}}</h5>

      </a>
    </div>
  </div>
</div>

<div class="card d-block d-sm-block d-md-block d-lg-none">
  <div  routerLink="/events/{{event.id}}" class="card-top">
    <img [src]="event.image" alt="Blog Name">
  </div>
  <div class="card-info" style="  padding: 0px 20px;">
    <h2 class="text-truncate text-center">{{event.name}}</h2>
    <span class="date text-center">{{event.dateStart | date : 'dd/MM/yyyy, h:mm a' : 'GMT'}}</span>
    <!-- <p class="excerpt">{{event.desc}}</p> -->
  </div>
  <div class="mb-2 flex-row  d-flex justify-content-center" style="  padding: 0px 20px;">
    <div class="col-12  d-flex justify-content-center  align-items-center row ">

      <button class="col-12 " routerLink="/events/{{event.id}}" mat-raised-button color="primary">
        <mat-icon>confirmation_number</mat-icon> COMPRAR AHORA
      </button>


    </div>
  </div>

  <div class="card-footer text-muted text-center">
    <div class="d-flex justify-content-center  align-items-center">
      <mat-icon>location_on</mat-icon>
      <a style="text-decoration: none;color:unset" href="https://www.google.cl/maps/search/{{event.address}}"
        target="_blank">
        <h5 style="margin-bottom: 0px;" class="text-truncate-2-line">{{event.address}}</h5>

      </a>
    </div>
  </div>
</div>
